/**
 * StealthStrip - Stealth's instruments over the map (plan design-gaps, L5).
 *
 * The rails fold the stealth pane into the target panel; this keeps what the
 * table reads at a glance in sight: the tracker's scope, the rung in force in
 * its own colour, a line of words saying what the tracker knows (2026-10-21,
 * "fix also the strip to be informative"; the canvas's Strip artboard), and at
 * Alarm the fight for whoever directs. The rung is a button: it opens the
 * target panel on its Stealth tab (the ladder, the opposition, the page).
 * Fed only by the published frame: nothing here can name a figure.
 *
 * @param {object} props
 * @param {object} props.stealth - hooks/useShellStealth's `stealth`
 * @param {object} props.fight - `{ sides, onStart }` for the alarm's Start the fight
 * @param {() => void} props.onOpen - put the Stealth pane in front (rightFront.show)
 */
import { useContext } from 'react';
import common from '../../styles/common.module.css';
import styles from '../../styles/Stealth.module.css';
import StartFight from '../StartFight';
import { TrackerScope, trackerWords } from './TrackerPanel';
import { RailsOpenContext } from '../shell/ShellColumns';
import { RUNG_LABELS } from '../../engine/stealth/ladder';

export default function StealthStrip({ stealth, fight, onOpen }) {
  const openRail = useContext(RailsOpenContext);
  const { state, canDirect } = stealth;
  const words = trackerWords(state.contacts);
  const open = () => {
    onOpen();
    openRail?.('target');
  };
  return (
    <div className={styles.strip} data-testid="stealth-strip">
      <TrackerScope contacts={state.contacts} className={styles.stripScope} />
      <div className={styles.stripWords}>
        <button
          type="button"
          className={styles.stripRung}
          data-testid="stealth-strip-rung"
          data-rung={state.rung}
          title="What they know about you - open the ladder"
          onClick={open}
        >
          {RUNG_LABELS[state.rung]}
        </button>
        <span className={styles.stripKnow} data-testid="stealth-strip-words" title={words}>
          {words}
        </span>
      </div>
      {state.rung === 'alarm' && canDirect && (
        <StartFight
          sides={fight.sides}
          onStart={fight.onStart}
          className={common.btnPrimary}
          testId="strip-start-fight"
        />
      )}
    </div>
  );
}
